var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,52)",
    d: "m0 0h18l13 2 16 6 11 6 14 10 12 11 9 10 11 15 10 16 12 21 15 26 12 21 13 22 15 26 16 28 15 26 11 19 15 26 12 21 10 17 12 21 14 24 15 26 12 21 16 27 6 11 11 19 30 52 14 24 16 28 14 24 16 28 14 24 15 26 16 28 15 26 14 24 30 52 12 21 10 17 12 21 12 23 7 17 6 23 2 15v10l-2 15-6 18-8 15-11 13-9 8-15 9-8 4-14 5-21 5-15 2h-968l-15-2-24-6-12-5-16-9-11-9-8-8-7-10-8-16-5-18-1-7v-19l5-23 7-21 9-19 14-24 10-18 10-17 9-16 28-48 9-16 12-21 10-17 12-20 6-11 24-42 14-24 16-28 10-17 11-19 12-21 14-24 24-42 10-17 13-22 6-11 5-9 9-15 15-26 20-35 15-26 10-17 8-13 6-11 9-16 12-21 15-25 6-11 28-49 6-10 8-14 14-24 13-22 7-10 8-10 9-10 8-8 15-11 12-7 17-6zm1 274-12 2-14 4-15 8-14 12-10 12-8 16-5 14-2 8v33l11 61 8 46 7 41 5 32 7 45 7 63 1 11 1 2h77l6-1 3-20 3-22 2-22 4-27 6-37 3-21 6-38 6-35 4-26 5-31 4-27v-26l-4-16-8-18-7-10-10-11-13-10-15-7-16-4-9-1zm-7 463-16 5-16 8-14 11-11 12-4 6-8 17-4 13v33l5 16 9 17 11 12 9 8 11 7 11 6 9 2 5 2h35l13-4 7-3 11-6 12-9 8-8 8-11 7-14 4-12 1-6v-29l-2-8-5-13-7-13-13-15-15-12-15-7-12-4-6-1z",
    fill: "#FEA504"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrash);
export default __webpack_public_path__ + "static/media/crash.e20e05f5dbd7bd1badebad7ea5c8cfca.svg";
export { ForwardRef as ReactComponent };